// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"b7a837bf","453":"35d6379b","777":"f356d9cd"}[chunkId] + ".chunk.js";
};